/**
 * Negrito por `**assim**` dentro do texto do `content/site.js`.
 *
 * Existe para o arquivo de conteúdo continuar sendo texto: quem escreve a
 * página marca a palavra que importa sem abrir um componente e sem escrever
 * JSX, e nós não precisamos de `dangerouslySetInnerHTML` — o texto é partido e
 * remontado em nós do React, então uma marcação errada vira asterisco na tela,
 * nunca HTML executado.
 */
function RichText({ children }) {
  const partes = String(children).split(/\*\*(.+?)\*\*/g);

  // O split com grupo de captura alterna: fora, dentro, fora, dentro… — os
  // índices ímpares são o que estava entre asteriscos.
  return partes.map((parte, i) =>
    i % 2 === 1 ? <strong key={i}>{parte}</strong> : parte,
  );
}

export default RichText;
